import { getAddress } from 'viem';

export type ReferralSignAction = 'create-referral-code' | 'use-referral-code';

export const buildReferralSignMessage = (
  action: ReferralSignAction,
  address: `0x${string}`,
  code: string,
  issuedAt: string,
): string =>
  [
    'Mezzanine Referral',
    `Action: ${action}`,
    `Address: ${getAddress(address)}`,
    `Code: ${code.trim().toLowerCase()}`,
    `Issued At: ${issuedAt}`,
  ].join('\n');

export const toReferralApiCode = (code: string): string => code.trim().toLowerCase();
